import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CheckIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 10, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 8) / 10}
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.76764 0.232287C9.45824 -0.0775267 8.95582 -0.0773314 8.646 0.232287L3.59787 5.28062L1.35419 3.03696C1.04438 2.72715 0.542174 2.72715 0.23236 3.03696C-0.0774534 3.34677 -0.0774534 3.84897 0.23236 4.15879L3.03684 6.96327C3.19165 7.11807 3.39464 7.19567 3.59765 7.19567C3.80067 7.19567 4.00386 7.11827 4.15867 6.96327L9.76764 1.3541C10.0775 1.0445 10.0775 0.542081 9.76764 0.232287Z"
        fill="currentColor"
      />
    </svg>
  )
})

CheckIcon.displayName = 'CheckIcon'
